import { isFutureDate } from './is-future-date.mjs';
import { TimeUnit } from './constants/index.mjs';

function isLessThanOneYearAway(date, now = new Date()) {
  return isFutureDate(date, now) && date.getTime() - now.getTime() < TimeUnit.Year;
}

export { isLessThanOneYearAway };
